/**
 * Single AuthClient instance shared by the entire demo site.
 *
 * Configurable via Vite env vars (build-time, not runtime — Vite
 * inlines `import.meta.env.VITE_*` at build):
 *   - `VITE_AUTH_SERVER_URL` — auth-server origin (e.g.
 *     `https://new-auth.vendidit.com`); `/api/v1` is appended.
 *   - `VITE_AUTH_APP_CODE` — defaults to "auth-client-demo"
 *
 * Default origin is chosen by build mode so that a forgotten env
 * doesn't accidentally point the live site at localhost:
 *
 *   - PROD build (`npm run build`)  → https://new-auth.vendidit.com
 *   - DEV build (`npm run dev`)     → http://localhost:8080
 *
 * `.env.production` and `.env.development` set the env var explicitly
 * so the mode-default only fires as a safety net.
 */
import { createAuthClient } from '@vendidit/auth-client';

const isProd = import.meta.env.PROD;
const defaultServerUrl = isProd ? 'https://new-auth.vendidit.com' : 'http://localhost:8080';

const serverUrl = import.meta.env.VITE_AUTH_SERVER_URL || defaultServerUrl;
const apiBaseUrl = `${serverUrl.replace(/\/+$/, '')}/api/v1`;
const appCode = import.meta.env.VITE_AUTH_APP_CODE || 'auth-client-demo';

// `bootstrap: 'auto'` so the AuthClient actively confirms session
// validity against /auth/me on mount — the demo gates the index on
// auth state, so a cached-but-revoked token MUST be detected before
// we render the catalog. The fetch is fire-and-forget; UI shows a
// short "Loading…" state until ready resolves.
export const auth = createAuthClient({
    apiBaseUrl,
    appCode,
    bootstrap: 'auto',
});

export const demoConfig = { apiBaseUrl, appCode };
